// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select_selectContainer__rhgpN {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 10px;
}

.Select_selectMenuList__AYqcP {
  padding: 10px;
}

.Select_selectMenuListButton__8nDU0 {
  width: 100%;
}

.Select_selectValueContainerButton__6xBk- {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
  outline: none;
  text-align: left;
}
.Select_selectValueContainerButton__6xBk-:focus {
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Select/Select.module.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YCCS;ADHX;;AAKA;EACE,aCRU;ADMZ;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAFF;AAGE;EACE,aAAA;AADJ","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.selectContainer {\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin: $margin-m;\n}\n\n.selectMenuList {\n  padding: $padding-m;\n}\n\n.selectMenuListButton {\n  width: 100%;\n}\n\n.selectValueContainerButton {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  outline: none;\n  text-align: left;\n  &:focus {\n    outline: none;\n  }\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectContainer": `Select_selectContainer__rhgpN`,
	"selectMenuList": `Select_selectMenuList__AYqcP`,
	"selectMenuListButton": `Select_selectMenuListButton__8nDU0`,
	"selectValueContainerButton": `Select_selectValueContainerButton__6xBk-`
};
export default ___CSS_LOADER_EXPORT___;
